import React from 'react';
import { FiExternalLink } from 'react-icons/fi';
import { ClickCard, DescriptionField, LinkFormProps, PasteLinkCard, SmallField, TitleField, useLinkForm } from './LinkCards';

// Add a podcast link: paste it, Investi fills in the rest (spec 412:13478)
const PodcastForm: React.FC<LinkFormProps> = props => {
    const form = useLinkForm('podcast', props, 'tab');
    return <>
        <PasteLinkCard icon={<FiExternalLink />} form={form} placeholder="https://… a Spotify, Apple Podcasts or podcast page link">
            <TitleField value={props.title} onChange={props.onTitle} />
            <div className="fields three hub-news-fields">
                <SmallField label="Source" hint="· shown under the title" value={form.fields[0]} onChange={v => form.setField(0, v)} />
                <SmallField label="Date shown on website" value={form.fields[1]} onChange={v => form.setField(1, v)} />
                <SmallField label="Length" hint="(optional)" value={form.fields[2]} onChange={v => form.setField(2, v)} />
            </div>
            <DescriptionField value={form.description} onChange={form.setDescription} />
        </PasteLinkCard>
        <ClickCard form={form} newTab="Open the podcast in a new tab" />
    </>;
};

export default PodcastForm;
